import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-dark-bg text-slate-200 selection:bg-accent-green/30">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-5xl">
        <Outlet />
      </main>
      <footer className="border-t border-dark-border py-6 mt-12">
        <div className="container mx-auto px-4 text-center space-y-2">
          <p className="text-sm text-slate-500 font-mono">
            &copy; {new Date().getFullYear()} Sakthivel Balakrishnan. All systems operational.
          </p>
          <p className="text-xs text-slate-600 font-mono">
            Hosted at <a href="https://codewithsakthi.com" className="text-accent-blue hover:underline">codewithsakthi.com</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
